export function trim(str) {
  return String.prototype.trim.call(str);
}

export function isType(arg, type) {
  return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach((param) => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

const DEFAULT_API_URL = "/";

function getLocationProtocol() {
  return typeof location !== "undefined" && location.protocol
    ? location.protocol
    : "http:";
}

export function normalizeApiUrl(url = DEFAULT_API_URL) {
  const value = String(url || DEFAULT_API_URL).trim();

  if (/^https?:\/\//i.test(value)) {
    const safeValue =
      getLocationProtocol() === "https:"
        ? value.replace(/^http:\/\//i, "https://")
        : value;
    return safeValue.replace(/\/+$/, "");
  }

  if (/^\/\//.test(value)) {
    return `${getLocationProtocol()}${value}`.replace(/\/+$/, "");
  }

  if (/^\//.test(value)) {
    const origin =
      typeof location !== "undefined" && location.origin ? location.origin : "";
    return `${origin}${value}`.replace(/\/+$/, "");
  }

  const protocol = getLocationProtocol() === "https:" ? "https://" : "http://";

  return `${protocol}${value.replace(/^\/+/, "")}`.replace(/\/+$/, "");
}

const VUE_APP_API_URL = normalizeApiUrl(process.env.VUE_APP_API_URL);
// const VUE_APP_API_URL = process.env.VUE_APP_API_URL || `${location.origin}/api`;
// const VUE_APP_WS_URL =  process.env.VUE_APP_WS_URL || `ws:${location.hostname}:20003`;
const VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || `wss:qk66//wss`;

export { VUE_APP_API_URL, VUE_APP_WS_URL };

